document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('collection-page')) {
    return;
  }

  const paginationDataEl = document.getElementById('collection-pagination-data');
  const placeholderEl = document.getElementById('breadcrumb-pagination-placeholder');
  const breadcrumbsListEl = document.querySelector('.breadcrumbs-list');

  if (!paginationDataEl || !placeholderEl || !breadcrumbsListEl) {
    return;
  }

  try {
    const paginationData = JSON.parse(paginationDataEl.textContent);
    if (paginationData.totalPages > 1) {
      const existingDivider = breadcrumbsListEl.querySelector('.icon');
      const dividerHtml = existingDivider ? existingDivider.outerHTML : '<span class="mx-2">/</span>';

      placeholderEl.innerHTML = `${dividerHtml} <span class="breadcrumbs-list__link--product">Page ${paginationData.currentPage} of ${paginationData.totalPages}</span>`;
      placeholderEl.style.display = 'flex';
      placeholderEl.style.alignItems = 'center';
    }
  } catch (e) {
    console.error('Error handling breadcrumb pagination:', e);
  }
});
